export default __webpack_public_path__ + "static/media/employecover.0f4db7d7.png";